import { render } from "./Trash.vue?vue&type=template&id=83f11a5c&scoped=true"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"

import "./Trash.vue?vue&type=style&index=0&id=83f11a5c&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f11a5c"]])

export default __exports__